module.exports = {
    "nosotros": "Sobre IRStrat",
    "servicios": "Servicios",
    "clientes": "Clientes",
    "propuesta": "Propuesta de valor",
    "perfil": "Perfil",
    "por_que": "¿Por qué IRStrat?",
    "equipo": "Equipo",
    "fundamentales": "Fundamentales de R.I.",
    "perfiles": "Perfiles",
    "testimonios": "Testimonios",
    "solicitud": "Solicitud de Información",
    "casos": "Casos de estudio",
    "incursion_mercado": "Incursión a los mercados",
    "emision_deuda_ce": "Emisión de Deuda",
    "programa_renta": "Renta Fija",
    "programa_ipo": "Programa IPO",
    "aumento_operatividad": "Aumento de liquidez",
    "posicionamiento": "Posicionamiento",
    "manejo_crisis": "Manejo de Crisis",
    "contacto": "Contacto",
    "analisis": "Análisis",
    "biblioteca": "Biblioteca RI",
    "noticias": "Noticias",
    "enlaces": "Destacados",
    "creado_por": "Creado por",
    "derechos_reservados": "Todos los derechos reservados",
    "aumento_liquidez": "Aumento de liquidez",
    "programa_ipo_medida": "IPO",
    "anual_sustentabilidad": "Informe Anual y de Sustentabilidad",
    "irstrat_footer": "IRStrat se enfoca en el mercado mexicano de renta fija y variable, poniendo a disposición de sus clientes una amplia red de contactos con las principales instituciones financieras nacionales e internacionales.",
    "telefono": "Tel"
}
